import { useCallback, useEffect, useRef, useState } from "react"
import styles from "./MeatBallsMenu.module.css"
import { Each } from "../common/Each"
import { ReactComponent as MenuIcon } from "../assets/images/icons/ic-menu.svg"
import useClickOutside from "../common/hooks/useClickOutside"

const MeatBallsMenu = ({ open = false, onChange = () => { }, disabled = false, actions = [], style = {}, menuIconStyle = {} }) => {
  const [_open, setOpen] = useState(open)
  const ref = useRef(null)
  const menuRef = useRef(null)
  const [menuPosition, setMenuPosition] = useState({ top: null, left: null })

  const updateMenuPosition = useCallback(() => {
    if (!ref.current) {
      return
    }

    const triggerRect = ref.current.getBoundingClientRect()
    const menuWidth = menuRef.current?.getBoundingClientRect().width ?? 0
    const left = menuWidth ? triggerRect.right - menuWidth : triggerRect.left

    setMenuPosition({
      top: triggerRect.bottom,
      left
    })
  }, [])

  useEffect(() => {
    setOpen(open)
  }, [open])

  useEffect(() => {
    onChange(_open)
  }, [_open])

  useEffect(() => {
    if (!_open) {
      return
    }

    updateMenuPosition()

    const handleReposition = () => updateMenuPosition()
    window.addEventListener("scroll", handleReposition, true)
    window.addEventListener("resize", handleReposition)

    return () => {
      window.removeEventListener("scroll", handleReposition, true)
      window.removeEventListener("resize", handleReposition)
    }
  }, [_open, updateMenuPosition])

  useClickOutside(ref, () => setOpen(false))

  const actionsStyle = {
    top: menuPosition.top !== null ? `${menuPosition.top}px` : undefined,
    left: menuPosition.left !== null ? `${menuPosition.left}px` : undefined,
    pointerEvents: _open ? "auto" : "none"
  }

  return (
    <>
      <div ref={ref} className={styles.container} style={style}>
        <MenuIcon
          style={{ opacity: disabled ? "0.5" : "1", cursor: disabled ? "default" : "pointer", ...menuIconStyle }}
          onClick={(e) => {
            e.stopPropagation()
            if (!disabled) {
              setOpen((o) => !o)
            }
          }} />
        <div
          ref={menuRef}
          className={`${styles.actions} ${_open ? styles.open : styles.closed}`}
          style={actionsStyle}
        >
          <Each
            of={actions}
            render={(action) => (
              <div className={styles.action} onClick={(e) => {
                e.stopPropagation()
                if (action.onClick && _open) {
                  action.onClick()
                  setOpen(false)
                }
              }}
                style={{ ...action.style ?? {} }}
              >
                {action.icon && <action.icon className={styles.icon} />}
                <div className={styles.label}>{action.label} </div>
              </div>
            )}
          />
        </div>
      </div>
    </>

  )
}


export default MeatBallsMenu
